import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmTableTr',
  props: {
  /**
   * Массив с ширинами колонок
   */
  columns: { type: Array as PropType<string[]>, default: () => [] },
},
  setup(__props) {

const props = __props;

const $el = ref<HTMLElement>();



const isMouseAtRow = ref(false);

const onLocalMouseover = () => {
  isMouseAtRow.value = true;
};

const onLocalMouseout = () => {
  isMouseAtRow.value = false;
};
/**
 * Стили
 */
let widthColumns = computed(() => {
  if (props.columns.length) return props.columns.join(" ");
  return "repeat(auto-fill, minmax(6.25rem, 1fr))";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table-grid-tr",
    ref_key: "$el",
    ref: $el,
    style: _normalizeStyle({ 'grid-template-columns': _unref(widthColumns) }),
    onMouseover: onLocalMouseover,
    onMouseout: onLocalMouseout
  }, [
    _renderSlot(_ctx.$slots, "default", { hover: isMouseAtRow.value })
  ], 36))
}
}

})